import React from 'react';
import PropTypes from 'prop-types';

import truncate from 'lodash/truncate';
import PlayerHeadshot from '~/components/PlayerHeadshot/PlayerHeadshot';
import StyledComponent from '~/components/Styled/Styled';
import getOr from '~/util/getOr';

import css from './AuthorCard.scss';

const normalizeAuthor = author => {
  const normalizedAuthor = {};
  const nameAsArray = author.name.split(' ');

  normalizedAuthor.full_name = author.name;
  normalizedAuthor.first_name = nameAsArray[0];
  normalizedAuthor.last_name = nameAsArray.slice(1).join(' ');

  normalizedAuthor.headshots = {
    author: getOr(author, 'headshot.url', '/static/vectors/default_avatar.svg'),
  };
  if (normalizedAuthor.headshots.author) normalizedAuthor.has_headshots = true;

  return normalizedAuthor;
};

/* eslint-disable react/prefer-stateless-function */

class AuthorCard extends React.Component {
  render() {
    const { author } = this.props;
    return (
      <div className={`${css.authorContainer} row`}>
        <div className="col-xs-3">
          <PlayerHeadshot player={normalizeAuthor(author)} size="author" key={author.id} />
        </div>
        <div className={`${css.authorTextBox} col-xs-9`}>
          <div>{author.name}</div>
          <div className={css.authorBio}>
            {truncate(author.bio, {
              length: 100,
              separator: /,? +/,
            })}
          </div>
        </div>
      </div>
    );
  }
}

const authorShape = PropTypes.shape({
  name: PropTypes.string,
  headshot: PropTypes.object,
  bio: PropTypes.string,
  id: PropTypes.number,
});

AuthorCard.propTypes = {
  author: authorShape.isRequired,
};

AuthorCard.displayName = 'AuthorCard';

export default StyledComponent(AuthorCard, [css]);
